import i18n from "@/i18n";
import { mapActions, mapState } from "vuex";
import moment from "moment";

export const changeLocale = {
  computed: {
    ...mapState("auth", ["user"]),
    locale() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions("common", ["changeLanguage"]),
    changeLocale(locale) {
      moment.locale(locale);
      i18n.locale = locale;
      localStorage.setItem("locale", locale);
      if (this.user) {
        this.changeLanguage(locale);
      }
    }
  }
};
